import styled from 'styled-components'

export const AmountWrapper = styled.div`
  width: auto;
  font-family: ${({ theme }) => theme.fontFamily.inter};
  p {
    font-style: normal;
    font-weight: 400;
    font-size: ${({ theme }) => theme.fontSize.s};
    line-height: 16px;
    color: ${({ theme }) => theme.colors.DarkCyan};
  }
  .check_full_withdrawal {
    display: flex;
    justify-content: end;
  }

  .withdraw_text {
    padding-top: 7px;
    font-style: normal;
    font-weight: 500;
    font-size: ${({ theme }) => theme.fontSize.s};
    line-height: 140%;
    color: ${({ theme }) => theme.colors.CollaboBlue};
    cursor: pointer;
  }
`
